module.exports = __webpack_public_path__ + "img/portugal-colorectal-cancer-male.b07f8606.png";